import { useRef, useState} from "react";
// import { set } from "react-hook-form";

// export default function useSubmitPrevent() {
//     return useRef(false);
// }

export default function usePreventMultiClick() {
    const [btnClicked, setBtnClicked] = useState(false);
    return {
        btnClicked,
        setBtnClicked
    };
}

// export default function useApiLoading() {
//     const [isLoading, setIsLoading] = useState(false);

//     return {
//         isLoading,
//         setIsLoading
//     };
// }